<app-oncall-home></app-oncall-home>
@if (pageEnabled) {
  <div class="tab-container">
    <div class="oncall-header team-title">
      <button mat-raised-button class="button" style="margin-bottom: 2rem;" (click)="goToTeamsPage()">Back To
      Teams</button>
      <p>{{ team.name }}</p>
    </div>
    @if (team.escalationPolicies.length === 0 && !showSplunkOnCallControls()) {
      <p style="color: red;">There are no escalation policies in place. By default, the current on-call team
        member will be notified every 10 minutes until the alert is acknowledged or resolved.
      </p>
    }
    <mat-tab-group style="min-width: 55%;" animationDuration="0ms">
      <mat-tab label="{{showSplunkOnCallControls() ? 'Splunk On-Call' : 'Members'}}">
        <div style="display: flex; flex-direction: column; align-items: center;">
          <div>
            <mat-checkbox [(ngModel)]="splunkOnCallIntegrated">Integrate With Splunk On-Call</mat-checkbox>
          </div>
          <div>
            @if (!showSplunkOnCallControls()) {
              <table class="mat-elevation-z8" #membersTable mat-table [dataSource]="dataSource" multiTemplateDataRows
                aria-describedby="members">
                <ng-container matColumnDef="select">
                  <th mat-header-cell class="header-row" style="width: 5px;" *matHeaderCellDef>
                    <mat-checkbox (change)="selectAllRows()" [checked]="allRowsSelected"
                      [indeterminate]="selection.hasValue() && !allRowsSelected">
                    </mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                      [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                  </td>
                </ng-container>
                @for (column of columns; track column) {
                  <ng-container [matColumnDef]="column.columnDef">
                    <th mat-header-cell class="header-row" *matHeaderCellDef>
                      {{ column.header }}
                    </th>
                    <td mat-cell *matCellDef="let member">
                      @if (column.columnDef !== 'onCall') {
                        {{ column.cell(member) }}
                      } @else {
                        @if (isOnCall(member)) {
                          <mat-icon class="material-icons-outlined"
                          style="color: #0093a1">done</mat-icon>
                        }
                      }
                    </td>
                  </ng-container>
                }
                <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
                <tr #tableRow mat-row *matRowDef="let teams; columns: displayedColumns;" style="height: 40px;">
                </tr>
              </table>
            }
            @if (!showSplunkOnCallControls()) {
              <div>
                <button mat-raised-button class="button" (click)="openAddTeamMemberDialog()">Add Members</button>
                <button mat-raised-button class="button" style="background-color: red;"
                  [ngStyle]="{'opacity': isRemoveMembersButtonEnabled() ? 1 : 0.5}"
                  [disabled]="!isRemoveMembersButtonEnabled()"
                  (click)="confirmAction('Are you sure you want to remove these members?', removeMembers, this.selection.selected)">Remove
                Members</button>
                <button mat-raised-button class="button"
                  [ngStyle]="{'opacity': isUpdateOnCallButtonEnabled() ? 1 : 0.5}"
                  [disabled]="!isUpdateOnCallButtonEnabled()"
                (click)="updateOnCallTeamMember(this.selection.selected[0])">Update On Call Member</button>
              </div>
            }
            @if (showSplunkOnCallControls()) {
              <div style="display: flex; flex-direction: column; align-items: center;">
                <mat-form-field style="width: 250px;" [ngStyle]="{'opacity': splunkOnCallIntegrated ? 1 : 0.5}">
                  <mat-label>Splunk On-Call Team Name</mat-label>
                  <input matInput [(ngModel)]="splunkOnCallTeamName" required="true">
                </mat-form-field>
                <mat-form-field style="width: 250px;" [ngStyle]="{'opacity': splunkOnCallIntegrated ? 1 : 0.5}">
                  <mat-label>Splunk On-Call Routing Key</mat-label>
                  <input matInput [(ngModel)]="splunkOnCallRoutingKey" required="true">
                </mat-form-field>
                <button mat-raised-button class="button"
                  [ngStyle]="{'opacity': isSaveTeamButtonEnabled() ? 1 : 0.5}"
                  [disabled]="!isSaveTeamButtonEnabled()"
                (click)="updateTeam(this.team)">Save Team</button>
              </div>
            }
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Support Hours">
        <div style="display: flex; flex-direction: column; align-items: center;">
          <div>
            <mat-checkbox [(ngModel)]="supportHoursEnabled">Enabled</mat-checkbox>
          </div>
          <div>
            <mat-button-toggle-group
              [disabled]="!supportHoursEnabled"
              [ngStyle]="{'opacity': supportHoursEnabled ? 1 : 0.5}"
              [(ngModel)]="supportHoursDays"
              name="supportDays" aria-label="days" multiple class="toggle-group">
              <mat-button-toggle value="Sunday">Sun</mat-button-toggle>
              <mat-button-toggle value="Monday">Mon</mat-button-toggle>
              <mat-button-toggle value="Tuesday">Tue</mat-button-toggle>
              <mat-button-toggle value="Wednesday">Wed</mat-button-toggle>
              <mat-button-toggle value="Thursday">Thu</mat-button-toggle>
              <mat-button-toggle value="Friday">Fri</mat-button-toggle>
              <mat-button-toggle value="Saturday">Sat</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
          <div>
            <div>
              <mat-label style="font-weight: bold;">From</mat-label>
            </div>
            <div>
              <mat-form-field>
                <input type="time" matInput [disabled]="!supportHoursEnabled" [(ngModel)]="supportHoursStartTime">
              </mat-form-field>
            </div>
            <div>
              <mat-label style="font-weight: bold;">to</mat-label>
            </div>
            <div>
              <mat-form-field>
                <input type="time" matInput [disabled]="!supportHoursEnabled" [(ngModel)]="supportHoursEndTime">
              </mat-form-field>
            </div>
            @if (supportHoursStartTime >= supportHoursEndTime) {
              <div>
                <mat-label style="font-weight: bold;">the next day</mat-label>
              </div>
            }
            <div>
              <mat-form-field style="width: 18rem;">
                <mat-select [disabled]="!supportHoursEnabled" [(ngModel)]="supportHoursTimeZone">
                  @for (timeZone of timeZones; track timeZone) {
                    <mat-option [value]="timeZone.value">
                      {{ timeZone.name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <!-- Persistent warning message for invalid support hours -->
          @if (!isSupportHoursFormValid() && supportHoursEnabled) {
            <div style="color: red; margin-top: 10px; margin-bottom: 10px; text-align: center; font-weight: bold; width: 100%;">
              Support hours configuration is invalid. Please ensure all fields (days, start/end times, timezone) are complete when enabling.
            </div>
          }
          <button mat-raised-button [ngStyle]="{'opacity': isSupportHoursFormValid() ? 1 : 0.5}" class="button"
          (click)="updateSupportHours()" [disabled]="!isSupportHoursFormValid()">Update Support Hours</button>
        </div>
      </mat-tab>
      @if (!showSplunkOnCallControls()) {
        <mat-tab label="Escalation Policies">
          <div style="display: flex; justify-content: space-around; padding-bottom: 0;">
            <button mat-raised-button class="button" (click)="updateEscalationPolicies()">Update Policies</button>
            <div style="align-items: center;">
              <span style="font-size: 16pt;">Example JSON</span>
            </div>
          </div>
          <form>
            <div style="display: flex; justify-content: space-around; padding-top: 0;">
              <div style="flex: 1;">
                <mat-form-field style="width: 100%;">
                  <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="14" cdkAutosizeMaxRows="14"
                    style="font-size: 14px;" id="escalationPoliciesJson" [(ngModel)]="escalationPoliciesJson"
                  [ngModelOptions]="{ standalone: true }">{{ escalationPoliciesJson }}</textarea>
                </mat-form-field>
              </div>
              <div style="flex: 1;">
                <mat-form-field style="width: 100%;">
                  <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="14" cdkAutosizeMaxRows="14"
                    style="font-size: 14px;" id="exampleEscalationPolicy"
                  disabled>{{ exampleEscalationPolicy }}</textarea>
                </mat-form-field>
              </div>
            </div>
          </form>
        </mat-tab>
      }
      <mat-tab label="Processing Workflows">
        <mat-tab-group animationDuration="0ms">
          <mat-tab label="Update Workflows">
            <div style="display: flex; justify-content: space-around; padding-bottom: 0;">
              <button mat-raised-button class="button" (click)="updateProcessingWorkflows()">Update Workflows</button>
              <div style="align-items: center;">
                <span style="font-size: 16pt;">Example JSON</span>
              </div>
            </div>
            <form>
              <div style="display: flex; padding-top: 0; padding-bottom: 0;">
                <div style="flex: 1;">
                  <mat-form-field style="width: 100%;">
                    <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="14" cdkAutosizeMaxRows="14"
                      style="font-size: 14px;" id="processingWorkflowJson" [(ngModel)]="processingWorkflowJson"
                    [ngModelOptions]="{ standalone: true }">{{ processingWorkflowJson }}</textarea>
                  </mat-form-field>
                </div>
                <div style="flex: 1;">
                  <mat-form-field style="width: 100%;">
                    <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="14" cdkAutosizeMaxRows="14"
                      style="font-size: 14px;" id="exampleProcessingWorkflow"
                    disabled>{{ exampleProcessingWorkflow }}</textarea>
                  </mat-form-field>
                </div>
              </div>
              <div style="padding-top: 0; padding-bottom: 0;">
                <p class="notes">
                  Rules are processed using Microsoft's <a
                href="https://github.com/microsoft/RulesEngine/wiki/Getting-Started" target="_blank" rel="noopener">RulesEngine</a>
                library.<br>
                Currently, only two parameters can be used in the rule expression: "alert" and "currentTime".<br>
                Double quotes in expressions must be escaped with a backslash.<br>
                The "alert" parameter references the payload of an alert using the <a
                href="https://learn.microsoft.com/en-us/azure/azure-monitor/alerts/alerts-common-schema#structure-of-the-common-schema"
              target="_blank" rel="noopener">common alert schema</a>.<br>
              <span style="color: red;">*Expressions that evaluate to true will cause processing to be skipped for
              the triggered alert.*</span>
            </p>
          </div>
        </form>
      </mat-tab>
      <mat-tab label="Rule Expression Tester">
        <div style="display: flex; justify-content: center;">
          <button mat-raised-button class="button" (click)="testProcessingWorkflow()"
          [disabled]="!this.testAlertPayload || !this.testExpression">Test Expression</button>
        </div>
        <form>
          <div style="display: flex; padding-top: 0; padding-bottom: 0;">
            <div style="flex: 1;">
              <mat-form-field style="width: 100%;">
                <textarea placeholder="Paste in an alert payload." matInput cdkTextareaAutosize
                  cdkAutosizeMinRows="14" cdkAutosizeMaxRows="14" style="font-size: 14px;" id="testAlertPayload"
                  [(ngModel)]="testAlertPayload"
                [ngModelOptions]="{ standalone: true }">{{ testAlertPayload }}</textarea>
              </mat-form-field>
            </div>
            <div style="flex: 1;">
              <mat-form-field style="width: 100%;">
                <textarea
                  placeholder="Paste in a single rule expression to be evaluated. Double quotes must be escaped with a backslash. Example: alert.Data.Essentials.AlertRule.Contains(\&quot;east\&quot;)"
                  matInput cdkTextareaAutosize cdkAutosizeMinRows="14" cdkAutosizeMaxRows="14"
                  style="font-size: 14px;" id="testExpression" [(ngModel)]="testExpression"
                [ngModelOptions]="{ standalone: true }">{{ testExpression }}</textarea>
              </mat-form-field>
            </div>
          </div>
        </form>
      </mat-tab>
    </mat-tab-group>
  </mat-tab>
</mat-tab-group>
</div>
} @else {
  <div>
    <h2>This page has been temporarily disabled by the Platform Team.</h2>
  </div>
}

